import { Typography } from 'antd'
import styled from 'styled-components'

const { Text: AntText } = Typography

export const TooltipContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border: 2px solid ${({ theme }) => theme.colors.grey2};
  border-radius: ${({ theme }) => theme.foundation.borderRadius};
  display: flex;
  flex-direction: column;
  padding: 10px;
`

export const TooltipText = styled(AntText)`
  color: ${({ theme }) => theme.colors.olive};
  font-size: 14px !important;
  font-weight: normal !important;
  line-height: 24px;
  margin-bottom: 0 !important;
`
